import { getPagesContainer } from "../../FeatureCard/utils/getPagesContainer";
import { useWidgetConfiguration } from "./useWidgetConfiguration";
import { useWidgetContext } from "./useWidgetContext";
import { WidgetType } from "../../FeatureCard/types";

export const useConfigPages = (type: WidgetType) => {
  const config = useWidgetConfiguration(type);
  const { page } = useWidgetContext(type);
  const pagesContainer = getPagesContainer(config.children);

  return {
    currentPage: pagesContainer?.children?.[page - 1] || null,
    currentPageIndex: page - 1,
    pages: pagesContainer?.children || [],
  };
};
